import Typography from "components/_blueprint/Typography"
import { CheckboxWithLabel } from "components/atoms/Checkbox"
import React from "react"
import styled from "styled-components"

interface CompletionDateWarningProps {
  children: React.ReactNode
  showWarning: boolean
  onChange: () => void
  checked: boolean
}

const CompletionDateCard = styled.div`
  background: #fbbb5b;
  border-radius: 16px;
  padding: 16px;
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    cursor: pointer;
  }
`

const CheckboxContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #000928;
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  align-self: stretch;

  :has(input:checked) {
    background: #000928;
    color: white;
  }
`

export const CompletionDateWarning = ({
  children,
  showWarning,
  onChange,
  checked,
}: CompletionDateWarningProps) => {
  return (
    <>
      {showWarning ? (
        <CompletionDateWarningWrapper checked={checked} onChange={onChange}>
          {children}
        </CompletionDateWarningWrapper>
      ) : (
        <>{children}</>
      )}
    </>
  )
}

const StrongText: React.FC = ({ children }) => {
  return <Typography.Text weight={600}>{children}</Typography.Text>
}

const CompletionDateWarningWrapper = ({
  children,
  checked,
  onChange,
}: Omit<CompletionDateWarningProps, "showWarning">) => {
  return (
    <CompletionDateCard>
      <Typography.Body weight={600}>What to consider before proceeding:</Typography.Body>
      <Typography.Text>
        <StrongText>Exchange:</StrongText> Switching is not possible if you have already exchanged
        contracts
      </Typography.Text>
      <Typography.Text>
        <StrongText>Withdrawal:</StrongText> Your current Mortgage Offer may be withdrawn to process
        this
      </Typography.Text>
      <Typography.Text>
        <StrongText>Credit:</StrongText> A new credit search may be required
      </Typography.Text>

      <CheckboxContainer>
        <CheckboxWithLabel
          onChange={onChange}
          checked={checked}
          id={`checkbox-completion-date-warning`}
        >
          I understand these risks and wish to proceed
        </CheckboxWithLabel>
      </CheckboxContainer>
      {children}
    </CompletionDateCard>
  )
}
